import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import {
  choiceDescriptionSx,
  choiceIconBoxSx,
  choiceIconSx,
  choiceTitleSx,
  getChoiceCardSx,
  sectionLabelSx,
} from './CadUploadFlow.styles';

const OPTIONS = [
  {
    id: 'manual',
    Icon: ListAltIcon,
    title: 'Lista vacía',
    description: 'Creá la lista y después sumá lotes desde el mapa o tus registros.',
  },
  {
    id: 'cad',
    Icon: MapOutlinedIcon,
    title: 'Desde un plano',
    description: 'Subí el plano de tu loteo en .dxf y creamos la lista con todos sus lotes.',
  },
];

/**
 * Primer paso de **Nueva lista**: elegir entre la lista de siempre o el alta
 * a partir de un plano. No cambia el flujo manual, solo lo antecede.
 *
 * @param {{
 *   value: 'manual'|'cad'|null,
 *   onChange: (id: string) => void,
 *   disableEmptyList?: boolean,
 * }} props
 */
export default function NewListKindChoice({ value, onChange, disableEmptyList = false }) {
  return (
    <Box>
      <Typography component="span" sx={sectionLabelSx}>
        ¿Cómo querés crear la lista?
      </Typography>
      <Box
        role="radiogroup"
        aria-label="Tipo de lista"
        sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}
      >
        {OPTIONS.map(({ id, Icon, title, description }) => {
          const disabled = id === 'manual' && disableEmptyList;
          const card = (
            <Button
              role="radio"
              aria-checked={value === id}
              disabled={disabled}
              onClick={() => onChange(id)}
              disableElevation
              sx={getChoiceCardSx(value === id, disabled)}
            >
              <Box sx={choiceIconBoxSx}>
                <Icon sx={choiceIconSx} />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={choiceTitleSx}>{title}</Typography>
                <Typography sx={choiceDescriptionSx}>{description}</Typography>
              </Box>
            </Button>
          );

          if (!disabled) return <React.Fragment key={id}>{card}</React.Fragment>;

          return (
            <Tooltip
              key={id}
              title="Hay un plano cargado. Quitá el archivo para elegir una lista vacía."
              placement="top"
              arrow
            >
              <Box component="span" sx={{ display: 'block', width: '100%' }}>{card}</Box>
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
}
